import i18next from 'i18next';

i18next.addResources('es', 'Task', {
  legalCases: 'Expedientes',
  emptyLegalCases: 'No se encontraron expedientes',
  assignees: 'Asignados',
  searchAssignees: 'Busca un asignado',
  emptyAssignes: 'No se encontraron asignados'
});

i18next.addResources('es', 'TaskCase', {
  legalCasesearchPlaceholder: 'Busca un expediente'
});

i18next.addResources('es', 'TaskType', {
  groupName: 'Tipo de tarea',
  audience: 'Audiencia',
  reminder: 'Recordatorio',
  expiration: 'Vencimiento',
  other: 'Otro'
});
